import React, { ReactElement } from "react";

import CheckPermissions from "../CheckPermissions";
import { LazyComponent } from "./lazy.types";

import type { UserManagementProps } from "@workflows/admin/user-management/UserManagement";

import { COMPONENTS, ERROR_TEXT } from "@utils/Constants";
import ErrorBoundary from "@utils/error-boundary/ErrorBoundary";

export const AdminUserManagementLazy = async (): LazyComponent<UserManagementProps> => {
  const { UserManagement } = await import("@workflows/admin/user-management/UserManagement");
  const WrappedUserManagement = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ADMIN_USER_MANAGEMENT}>
      <ErrorBoundary fallbackMessage={ERROR_TEXT.USER_MANAGEMENT}>
        <UserManagement />
      </ErrorBoundary>
    </CheckPermissions>
  );
  return { Component: WrappedUserManagement };
};

export const AdminUserAccessRequestLazy = async (): LazyComponent<UserManagementProps> => {
  const { UserManagement } = await import("@workflows/admin/user-management/UserManagement");
  const WrappedUserManagement = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ADMIN_ACCESS_REQUESTS}>
      <ErrorBoundary fallbackMessage={ERROR_TEXT.USER_MANAGEMENT}>
        <UserManagement tab={1} />
      </ErrorBoundary>
    </CheckPermissions>
  );
  return { Component: WrappedUserManagement };
};

export const AdminUserPreferencesLazy = async (): LazyComponent<unknown> => {
  const { UserManagementPreferences } = await import("@workflows/admin/user-preferences/UserManagementPreferences");
  const WrappedUserManagement = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ADMIN_USER_PREFERENCES}>
      <ErrorBoundary fallbackMessage={ERROR_TEXT.USER_PREFERENCES}>
        <UserManagementPreferences />
      </ErrorBoundary>
    </CheckPermissions>
  );
  return { Component: WrappedUserManagement };
};
